import { FC, useState, useEffect } from 'react';
import { Alert, Box, Grid } from '@mui/material';
import { format } from 'date-fns';

import { Contract } from 'src/models/subscription';
import { Membership } from 'src/models/membership';
import { SubscriptionSeats } from './ProSeats';

type Props = {
  contract?: Contract;
  membership: Membership;
  isExpired: boolean;
};

const UserMembershipContract: FC<Props> = ({
  contract,
  membership,
  isExpired
}) => {
  if (!contract) {
    return null;
  }

  return (
    <Box
      sx={{
        mb: 1,
        mt: 2,
        backgroundColor: '#0b5466',
        color: '#ffffff',
        padding: '1rem',
        borderRadius: '1rem',
        border: '1px solid #0b5466'
      }}
    >
      <Grid container spacing={4}>
        <Grid item sm={3}>
          <p>
            <strong>Contract Accepted: </strong>
            {format(new Date(contract.acceptedAt.formatted), 'MMM dd, yyyy')}
          </p>
        </Grid>
        <Grid item sm={3}>
          <p>
            <strong>Discount: </strong>
            {contract.discountPercent * 100}%
          </p>
        </Grid>
        <Grid item sm={3}>
          <p>
            <strong>{contract.periodsInTerm} Month Term: </strong>
            {(isExpired
              ? 'Ended '
              : contract.cancelAtRenewalDate
                ? 'Ends '
                : 'Renews ') +
              format(new Date(contract.renewalDate.formatted), 'MMM dd, yyyy')}
          </p>
        </Grid>
        <Grid item sm={3}>
          <SubscriptionSeats membership={membership} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default UserMembershipContract;
